import Amount from '@/types/Amount';

export default class ItemInformation {
    public itemInformationId: string;
    public itemId: string;
    public orderId: string;
    public purchasePrice: Amount;
    public purchaseDateTime: Date;
    public soldDateTime: Date;
    public soldAt: string;
}
